
import request from '@/utils/request'

// 获取将康评分
export function fetchScore(query) {
  return request({
    url: '/api/v1/healthscorelastandstartendtime',
    method: 'get',
    params: query
  })
}

// 获取各个健康数据最新一条数据
export function fetchHealth(query) {
  return request({
    url: '/api/v1/healthdatafirst',
    method: 'get',
    params: query
  })
}

// 获取某时间段每天最新一条数据接口
export function fetchHealths(query) {
  return request({
    url: '/api/v1/healthdataofstartendtime',
    method: 'get',
    params: query
  })
}

// 健康建议
export function fetchSuggest(query) {
  return request({
    url: '/api/v1/healthadvice/page',
    method: 'get',
    params: query
  })
}

// 健康预警
export function fetchWarning(query) {
  return request({
    url: '/api/v1/heathwarning/page',
    method: 'get',
    params: query
  })
}
// 健康报告列表
export function fetchReports(query) {
  return request({
    url: '/api/v1/healthreport/page',
    method: 'get',
    params: query
  })
}

// 健康报告详情
export function fetchReport(query) {
  return request({
    url: '/api/v1/healthreportdata',
    method: 'get',
    params: query
  })
}

// 血压列表
export function fetchBp(query) {
  return request({
    url: '/api/v1/bloodpressure/page',
    method: 'get',
    params: query
  })
}
// 血压录入
export function postBp(data) {
  return request({
    url: '/api/v1/bloodpressure',
    method: 'post',
    data
  })
}

// 血糖列表
export function fetchBs(query) {
  return request({
    url: '/api/v1/bloodsugar/page',
    method: 'get',
    params: query
  })
}
// 血糖录入
export function postBs(data) {
  return request({
    url: '/api/v1/bloodsugar',
    method: 'post',
    data
  })
}

// 心率列表
export function fetchHb(query) {
  return request({
    url: '/api/v2/heartstate/page',
    method: 'get',
    params: query
  })
}
// 心率录入
export function postHb(data) {
  return request({
    url: '/api/v1/heartbeat',
    method: 'post',
    data
  })
}

// 血氧列表
export function fetchBo(query) {
  return request({
    url: '/api/v1/bloodoxygen/page',
    method: 'get',
    params: query
  })
}
// 血氧录入
export function postBo(data) {
  return request({
    url: '/api/v1/bloodoxygen',
    method: 'post',
    data
  })
}

// 步数列表
export function fetchStep(query) {
  return request({
    url: '/api/v1/walkstep/page',
    method: 'get',
    params: query
  })
}
// 步数录入
export function postStep(data) {
  return request({
    url: '/api/v1/walkstep',
    method: 'post',
    data
  })
}

// 获取呼吸暂停分页数据接口
export function fetchPause(query) {
  return request({
    url: '/api/v1/breathpause/page',
    method: 'get',
    params: query
  })
}
// 呼吸暂停录入
export function postPause(data) {
  return request({
    url: '/api/v1/breathpause',
    method: 'post',
    data
  })
}

// 获取hrv分页数据接口
export function fetchHRV(query) {
  return request({
    url: '/api/v1/hrv/page',
    method: 'get',
    params: query
  })
}
// 呼吸暂停录入
export function postHRV(data) {
  return request({
    url: '/api/v1/hrv',
    method: 'post',
    data
  })
}

// 获取血糖的标准值配置信息
export function getSugarConfigInfo(query) {
  return request({
    url: '/api/v1/healthrange',
    method: 'get',
    params: query
  })
}

export function setSugarConfigInfo(data) {
  return request({
    url: '/api/v1/healthrange',
    method: 'post',
    data
  })
}

// 血糖的统计接口
export function getUserSugarData(query) {
  return request({
    url: '/api/v1/non/sugar/static',
    method: 'get',
    params: query
  })
}

export function getNearHeartData() {
  return request({
    url: '/api/v1/healthdatafirst',
    method: 'get'
  })
}
